module.exports = __webpack_public_path__ + "static/media/bg-4000.bb35c906.jpeg";